<template>
  <div>
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="">
        <PageHeaderPart
            style="font-family: OpenSans-Bold"
          :pageHeaderImage="guardiansHeaderImg"
          pageHeaderImageAltText="Guadian Head Image"
          :pageHeading="$root.selectedLanguageData.guardian_info"
          :pageInfo="$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`? $root.selectedLanguageData.tellUsMoreAboutGuardian: $root.selectedLanguageData.tellUsMoreAboutYou"
        />
        <div class="columns is-7 is-variable mt-5">
          <div class="column is-one-third">
            <SelectLabel
              :label="$root.selectedLanguageData.title"
              v-model="$root.formData.guardian_title"
              :validationRules="{ required: true }"
              :selectOptions="$root.selectedLanguageData.titleList"
              required="true"
              fieldName="Title"
            />
          </div>
          <div class="column">
            <InputLabel
              required="true"
              :label="$root.selectedLanguageData.surname"
              v-model="$root.formData.guardian_surname"
              :validationRules="validateName()"
              fieldName="Name"
            />
          </div>
        </div>
        <InputLabel
          required="true"
          :label="$root.selectedLanguageData.otherName"
          v-model="$root.formData.guardian_other_name"
          :validationRules="validateName()"
          fieldName="Othername"
        />
        <RadioButtonField
          :label="$root.selectedLanguageData.gender"
          :validationRules="{ required: true }"
          v-model="$root.formData.guardian_gender"
          :radioOptions="$root.selectedLanguageData.gender_list"
          name="Gender"
          styles="mt-5"
          itemList="residentship-item"
        />
        <RadioButtonField
            v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'"
          :label="$root.selectedLanguageData.maritalStatus"
          :validationRules="{ required: true }"
          v-model="$root.formData.guardian_marital_status"
          @input="
            (receivedValue) => {
              if (!receivedValue) {
                $root.formData.guardian_spouse_name = ``;
              }
            }
          "
          :radioOptions="$root.selectedLanguageData.marital_status_list"
          name="Guardian Marital Status"
          styles="mt-5"
          itemList="residentship-item"
        />
        <InputLabel
          required="true"
          v-if="$root.formData.guardian_marital_status === `Married`"
          :label="$root.selectedLanguageData.spouse_name"
          v-model="$root.formData.guardian_spouse_name"
          :validationRules="validateName()"
          fieldName="Spousename"
        />
<!--        <InputLabel-->
<!--          required="true"-->
<!--          :label="$root.selectedLanguageData.relationship_to_the_acc_holder"-->
<!--          v-model="$root.formData.relationship_to_the_acc_holder"-->
<!--          :validationRules="validateRequeredLine()"-->
<!--          styles="mt-5"-->
<!--          fieldName="Relationship"-->
<!--        />-->
        <SelectLabel
            :label="$root.selectedLanguageData.relationship_to_the_acc_holder"
            v-model="$root.formData.relationship_to_the_acc_holder"
            :validationRules="{ required: true }"
            :selectOptions="$root.selectedLanguageData.relationshipList"
            required="true"
            styles="mt-5"
            fieldName="Relationship to the account holder"
        />

        <hr  v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'"/>

        <RadioButtonField
            
          :label="$root.selectedLanguageData.residency"
          :validationRules="{ required: true }"
          v-model="$root.formData.guardian_residency"
          :radioOptions="$root.selectedLanguageData.residency_list"
          name="Residency"
          styles="mt-5"
          itemList="residentship-item"
        />


<!--          <SelectLabel-->
<!--              v-if="($root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No')&& $root.formData.guardian_residency === 'Out of Sri Lanka'"-->
<!--              :label="$root.selectedLanguageData.specifyTheCountry"-->
<!--              v-model="$root.formData.guardian_tittle"-->
<!--              :validationRules="{ required: true }"-->
<!--              :selectOptions="countriesArray"-->
<!--              :key="value"-->
<!--              :value="value"-->
<!--              required="true"-->
<!--              fieldName="Title"-->
<!--          />-->
        <div  v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">
          <div>
            <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
              {{
                $root.selectedLanguageData
                    .specifyTheCountry
              }}<span class="has-text-danger">*</span></label>

            <div>
              <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                <div style="width: 100%">
                  <b-select @focus="$inputFocused('guardian_resident_country')"
                            @input="$inputChanged('guardian_resident_country')"
                            @blur="$inputBlured('guardian_resident_country')" v-model="$root.formData.guardian_resident_country"
                            expanded>
                    <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                      {{ country.countryName }}
                    </option>
                  </b-select>
                </div>
                <span class="has-text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>


        <SelectLabel
          :label="$root.selectedLanguageData.nationalityCitizenship"
          v-model="$root.formData.guardian_nationality_citizenship"
          :validationRules="{ required: true }"
          :selectOptions="$root.selectedLanguageData.citizenship_list"
          required="true"
          styles="mt-5"
          fieldName="Nationality"
        />

        <div  v-if="($root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No')&& $root.formData.guardian_nationality_citizenship === 'Sri Lankan with Dual Citizenship' || $root.formData.guardian_nationality_citizenship === 'Sri Lankan with Foreign Citizenship'||$root.formData.guardian_nationality_citizenship ==='Foreign National'" >
          <div>
            <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
              {{
                $root.selectedLanguageData
                    .specifyTheCountry
              }}<span class="has-text-danger">*</span></label>

            <div>
              <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                <div style="width: 100%">
                  <b-select @focus="$inputFocused('guardian_citizenship_country')"
                            @input="$inputChanged('guardian_citizenship_country')"
                            @blur="$inputBlured('guardian_citizenship_country')" v-model="$root.formData.guardian_citizenship_country"
                            expanded>
                    <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                      {{ country.countryName }}
                    </option>
                  </b-select>
                </div>
                <span class="has-text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>

<!--        <SelectLabel-->
<!--            v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'"-->
<!--            :label="$root.selectedLanguageData.specifyTheCountry"-->
<!--            v-model="$root.formData.guardian_tittle"-->
<!--            :validationRules="{ required: true }"-->
<!--            :selectOptions="$root.selectedLanguageData.citizenship_lis"-->
<!--            required="true"-->
<!--            fieldName="Title"-->
<!--        />-->

<!--        <hr />-->
        <b-field v-if="$root.formData.haveNic === 'No'">
          <b-checkbox
            :true-value="true"
            :false-value="false"
            v-model="$root.formData.guardian_details_are_different"
            name="guardian_details_are_different"
            @input="()=>{guardianContactDetailsMatcher()}"
          ></b-checkbox>
          <p class="gray_font">
            {{
              $root.selectedLanguageData
                .tick_here_if_the_guardian_details_are_different
            }}
          </p>
        </b-field>
        <div class="mt-5"  v-if="$root.formData.haveNic === 'No' || $root.formData.childrenAccountOpeningPurpose === 'For another person\'s child (Gift Account)'">
          <label
            >{{ $root.selectedLanguageData.mobile_number
            }}<span class="has-text-danger">*</span></label
          >
          <div class="columns is-7 is-variable">
            <div class="column is-one-third">
              <div>
                <section>
                  <b-field>
                    <p class="control has-icons-right">

                      <b-autocomplete
                          :disabled="!$root.formData.guardian_details_are_different && $root.formData.childrenAccountOpeningPurpose !== 'For another person\'s child (Gift Account)'"
                        class="co-code"
                        v-model="userCode"
                          :select-on-click-outside="true"

                        open-on-focus
                        :data="filteredDataArr"
                        icon-pack="fi"
                        :icon="iconString"
                        @input="
                          () => {
                            ++count;
                            if (count === 2) {
                              $root.formData.guardian_countryCode = ``;
                              isCountryCodeTouched = true;
                            }
                          }
                        "
                        @select="
                          (option) => {
                            if (option) {
                              $root.formData.guardian_country_short_name = `${
                                option.split(` `)[1]
                              }`;
                              $root.formData.guardian_countryCode = `${
                                option.split(` `)[0]
                              }`;
                            } else {
                              $root.formData.guardian_country_short_name = ``;
                              $root.formData.guardian_countryCode = ``;
                            }
                            if ($root.formData.guardian_country_short_name) {
                              changeSelection();
                              calPhoneNumber();
                              mobileNumValidate();
                            }
                          }
                        ">
                      </b-autocomplete>
                      <span class="icon is-small is-right ml-6">
                        <img
                          src="@/assets/images/icons/Blue/Stroke.png"
                          alt="Stroke-3-img"
                          width="15"
                        />
                      </span>
                      <span
                        class="has-text-danger"
                        v-if="
                          isCountryCodeTouched &&
                          !$root.formData.guardian_countryCode
                        "
                        >You have to select a valid country code</span
                      >
                    </p>
                  </b-field>
                </section>
              </div>
            </div>
            <div class="column">
              <b-field>

<!--                :disabled="!$root.formData.guardian_details_are_different"-->
                <b-input
                    :disabled="!$root.formData.guardian_details_are_different && $root.formData.childrenAccountOpeningPurpose !== 'For another person\'s child (Gift Account)'"
                  class="co-code-2"
                  expanded
                  type="tel"
                  v-model="$root.formData.guardian_mobileNumber"
                  @input="
                    () => {
                      calPhoneNumber();
                      mobileNumValidate();

                    }
                  "
                ></b-input>

                <span
                  class="has-text-danger"
                  v-if="isMobileNumberStartsWithZero"
                  >LK phone numbers not allowed to start with 0</span
                ><span
                  class="has-text-danger"
                  v-else-if="isMobileNumberTouched && !isMobileNumberValid"
                  >Please enter a valid phone number</span
                >
              </b-field>
            </div>
          </div>
        </div>
        <InputLabel
            v-if="$root.formData.haveNic === 'No' || $root.formData.childrenAccountOpeningPurpose === 'For another person\'s child (Gift Account)'"
            :disabled="!$root.formData.guardian_details_are_different && $root.formData.childrenAccountOpeningPurpose !== 'For another person\'s child (Gift Account)'"
          :required="$root.formData.childrenAccountOpeningPurpose !== `For another person's child (Gift Account)`"
          :label="$root.selectedLanguageData.emailAddress"
          v-model="$root.formData.guardian_email"
          :validationRules="{
            email: true,
            lessOrEqualLength: 256,
          }"
          styles="mt-5"
          fieldName="Email ID"
        />
        <hr  v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'" />



<!--important to add below div    v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'"-->
        <div v-if="$root.formData.childrenAccountOpeningPurpose === 'For my own child' || $root.formData.haveNic === 'No'">
        <div class="columns">
          <div class="column">
            <InputLabel
              :label="$root.selectedLanguageData.driving_licence"
              v-model="$root.formData.guardian_driving_licence"
              fieldName="Your Licence number"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <InputLabel
              :required="$root.formData.guardian_residency === 'Out of Sri Lanka'"
              :label="$root.selectedLanguageData.passport_no"
              v-model="$root.formData.guardian_passport"
              :validationRules="passportValidateObject()"
              fieldName="Your passport number"
            />
          </div>
          <div class="column mt-2">
            <label
              >{{ $root.selectedLanguageData.passport_issued_date
              }}<span class="has-text-danger" v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">*</span></label
            >
            <b-field>
              <p class="control has-icons-right">
                <b-datepicker
                    @focus="$inputFocused('guardian_passport_issue_date')"
                    @blur="$inputBlured('guardian_passport_issue_date')"
                    @input="$inputChanged('guardian_passport_issue_date'); passportExpireDateCalculator()"
                    :disabled="$root.formData.guardian_passport === ''"
                  class="date-picking"
                  :required="$root.formData.guardian_residency === 'Out of Sri Lanka'"
                  :append-to-body="true"
                  v-model="$root.formData.guardian_passport_issue_date"
                  :max-date="new Date()"
                >
                </b-datepicker>

                <span class="icon is-small is-right">
                  <img
                    src="@/assets/images/icons/Blue/Calendar.webp"
                    alt="Calendar-img"
                    width="25"
                    height="25"
                  />
                </span>
              </p>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column mt-2 is-half">
            <label
              >{{ $root.selectedLanguageData.passport_expiry_date
              }}<span class="has-text-danger"  v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">*</span></label
            >
            <b-field>
              <p class="control has-icons-right">
                <b-datepicker
                    :disabled="$root.formData.guardian_passport === ''"
                    :required="$root.formData.guardian_residency === 'Out of Sri Lanka'"
                    class="date-picking"
                  :append-to-body="true"
                  v-model="$root.formData.guardian_passport_expiry_date"
                  :min-date="new Date()"
                >
                </b-datepicker>

                <span class="icon is-small is-right">
                  <img
                    src="@/assets/images/icons/Blue/Calendar.webp"
                    alt="Calendar-img"
                    width="25"
                    height="25"
                  />
                </span>
              </p>
            </b-field>
          </div>

          <div class="column is-half" v-if="$root.formData.haveNic==='No' || $root.isPreviouslyDonorFilled === 1">
            <InputLabel
                required="true"
                :label="$root.selectedLanguageData.nic_number"
                v-model="$root.formData.guardian_nic"
                @input="calculateDateOfBirth()"
                :validationRules="{
                required: true,
                multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/],
              }"
                :component-function-one="splitNic()"
                fieldName="Your NIC number"
            />
          </div>

        </div>
        <hr />
        <p class="is-size-5">
          <b> {{ $root.selectedLanguageData.permanentAddress }}</b>
        </p>
        <InputLabel
          required="true"
          :label="$root.selectedLanguageData.houseName"
          v-model="$root.formData.guardian_house_name"
          :validationRules="{
            required: true,
          }"
          fieldName="House name"
        />
        <div class="columns mt-2">
          <div class="column">
            <InputLabel
              required="true"
              :label="$root.selectedLanguageData.streetName"
              v-model="$root.formData.guardian_street_name"
              :validationRules="{
                required: true,
              }"
              fieldName="Street name"
            />
          </div>
          <div class="column">
            <InputLabel
              required="true"
              :label="$root.selectedLanguageData.city"
              v-model="$root.formData.guardian_city"
              :validationRules="{
                required: true,
              }"
              fieldName="City"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <InputLabel
              :label="$root.selectedLanguageData.postalCode"
              v-model="$root.formData.guardian_postal_code"
              :validationRules="{
                  regex: /^\d{5}$/, notEndsWith: ' ' 
              }"
              fieldName="Postal code"
            />
          </div>
          <div class="column">
            <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
              <b-field>
                <template #label
                  >{{ $root.selectedLanguageData.country
                  }}<span class="has-text-danger">*</span></template
                >

                <p class="control has-icons-right">
                  <b-autocomplete
                    v-model="permanentaddresscountry"
                    open-on-focus
                    :data="countryFilteredDataArray"
                    @select="
                      (option) => {
                        if (option) {
                          $root.formData.guardian_country = option.name;
                          permanentaddresscountry = option.name;
                          permanentaddresscountrycount = -1;
                        } else {
                          $root.formData.guardian_country = ``;
                          permanentaddresscountry = ``;
                        }
                      }
                    "
                    @input="
                      () => {
                        ++permanentaddresscountrycount;
                        if (!permanentaddresscountry) {
                          isPermanentAddressCountryTouched = false;
                          $root.formData.guardian_country = ``;
                        } else if (permanentaddresscountry) {
                          isPermanentAddressCountryTouched = false;
                          $root.formData.guardian_country =
                            permanentaddresscountry;
                        } else if ($root.formData.guardian_country) {
                          if (permanentaddresscountrycount > 1) {
                            isPermanentAddressCountryTouched = true;
                            $root.formData.guardian_country = ``;
                          }
                        } else if (permanentaddresscountrycount > 0) {
                          isPermanentAddressCountryTouched = true;
                          $root.formData.guardian_country = ``;
                        }
                      }
                    "
                    placeholder=""
                    icon=""
                    field="name"
                  >
                    <template #empty>No results found</template>
                  </b-autocomplete>
                  <span class="icon is-small is-right mx-2">
                    <img
                      src="@/assets/images/icons/Blue/Stroke.png"
                      alt="Stroke-img"
                      width="15"
                      height="15"
                    />
                  </span>
                </p>
              </b-field>
              <span
                class="has-text-danger"
                v-if="
                  isPermanentAddressCountryTouched &&
                  !$root.formData.guardian_country
                "
                >You have to select a valid country</span>
              <span class="has-text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <!-- mailing address -->
        <p class="is-size-5">
          <b> {{ $root.selectedLanguageData.mailingAddress }}</b>
        </p>
        <b-field>
          <b-checkbox
            :true-value="true"
            :false-value="false"
            v-model="$root.formData.guardian_mailing_address_different"
            name="mailing_address_is_different"
            @input="guardianMailingAddressSameAsPermanentAddess()"
            :disabled="$root.formData.guardian_house_name === ''|| $root.formData.guardian_street_name=== ''|| $root.formData.guardian_city=== '' || permanentaddresscountry=== ''"
          ></b-checkbox>
          <p class="gray_font" style="font-size: 0.9rem">
            {{ $root.selectedLanguageData.sameAsPermanentAddress }}
          </p>
        </b-field>
<!--          v-if="!$root.formData.guardian_mailing_address_different"-->
        <div>
          <InputLabel
            required="true"
            :label="$root.selectedLanguageData.houseName"
            v-model="$root.formData.guardian_mailing_house_name"
            :validationRules="{
              required: true,
            }"
            fieldName="House name"
          />
          <div class="columns mt-2">
            <div class="column">
              <InputLabel
                required="true"
                :label="$root.selectedLanguageData.streetName"
                v-model="$root.formData.guardian_mailing_street_name"
                :validationRules="{
                  required: true,
                }"
                fieldName="Street name"
              />
            </div>
            <div class="column">
              <InputLabel
                required="true"
                :label="$root.selectedLanguageData.city"
                v-model="$root.formData.guardian_mailing_city"
                :validationRules="{
                  required: true,
                }"
                fieldName="City"
              />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <InputLabel

                :label="$root.selectedLanguageData.postalCode"
                v-model="$root.formData.guardian_mailing_postal_code"
                :validationRules="{
                    regex: /^\d{5}$/, notEndsWith: ' ' 
                }"
                fieldName="Postal code"
              />
            </div>
            <div class="column">
              <ValidationProvider
                :rules="{ required: true }"
                v-slot="{ errors }"
              >
                <b-field>
                  <template #label
                    >{{ $root.selectedLanguageData.country
                    }}<span class="has-text-danger">*</span></template
                  >

                  <p class="control has-icons-right">
                    <b-autocomplete
                      v-model="mailingaddresscountry"
                      open-on-focus
                      :data="mailingCountryFilteredDataArray"
                      @select="
                        (option) => {
                          if (option) {
                            $root.formData.guardian_mailing_country =
                              option.name;
                            mailingaddresscountry = option.name;
                            mailingaddresscountrycount = -1;
                          } else {
                            $root.formData.guardian_mailing_country = ``;
                            mailingaddresscountry = ``;
                          }
                        }
                      "
                      @input="
                        () => {
                          ++mailingaddresscountrycount;
                          if (!mailingaddresscountry) {
                            isMailingAddressCountryTouched = false;
                            $root.formData.guardian_mailing_country = ``;
                          } else if (mailingaddresscountry) {
                            isMailingAddressCountryTouched = false;
                            $root.formData.guardian_mailing_country =
                              mailingaddresscountry;
                          } else if ($root.formData.guardian_mailing_country) {
                            if (mailingaddresscountrycount > 1) {
                              isMailingAddressCountryTouched = true;
                              $root.formData.guardian_mailing_country = ``;
                            }
                          } else if (mailingaddresscountrycount > 0) {
                            isMailingAddressCountryTouched = true;
                            $root.formData.guardian_mailing_country = ``;
                          }
                        }
                      "
                      placeholder=""
                      icon=""
                      field="name"
                    >
                      <template #empty>No results found</template>
                    </b-autocomplete>
                    <span class="icon is-small is-right mx-2">
                      <img
                        src="@/assets/images/icons/Blue/Stroke.png"
                        alt="Stroke-img"
                        width="15"
                        height="15"
                      />
                    </span>
                  </p>
                </b-field>
                <span
                  class="has-text-danger"
                  v-if="
                    isMailingAddressCountryTouched &&
                    !$root.formData.guardian_mailing_country
                  "
                  >You have to select a valid country</span
                >
                <span class="has-text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>

          <!-- contactNumberResident -->
          <div class="mt-5">
            <div class="icon-text" :style="{
                    cursor: 'pointer',
                    color: '#009ec2',
                    'line-height': '20px',
                    'text-decoration': 'underline',
                    'letter-spacing': '0.7px',
                  }">
              <p v-if="!isShow" @click="contactNumberResidentVisible()">
                      <span class="icon has-text-info">
                        <img src="../../../assets/images/icons/Blue/Circle Plus.png" alt="Circle_Plus image" />

                      </span>
                <span v-if="!isShow">{{$root.selectedLanguageData.contactNumberResident }}</span>
              </p>
            </div>

            <div v-if="isShow">
              <div v-if="isShow" @click="() => {contactNumberResidentInvisible();changeResidentialSelection(); $root.formData.residanceContactNumWithOutCode = ''; $root.formData.residenceCountryCode='+94'}" class="mb-2">


                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        <span class="icon has-text-info mr-2">
                          <img src="../../../assets/images/icons/Blue/Circle Minus.png"
                               alt="Circle_Mini image" />
                        </span>

                  {{ $root.selectedLanguageData.contactNumberResident }}
                </label>
              </div>

              <div class="columns is-7 is-variable">
                <div class="column is-one-third">
                  <div>
                    <section>
                      <b-field>
                        <p class="control has-icons-right">

                          <ValidationProvider name="Country Code"
                                              v-slot="{ errors }">
                            <b-autocomplete autocomplete="code_two" @input="residenceCountryCodeLogoFilter" v-model ="$root.formData.guardianResidenceCountryCode" placeholder="guardian country Code" icon-pack="fi" :icon="$root.formData.guardianCountryIconStringResidance"
                                            :data="residenceFilteredDataArray"
                                            clearable
                                            :select-on-click-outside="true"
                                            :open-on-focus ="true"
                                            @select="option => selected = option">
                              <template #empty>No results found</template>
                            </b-autocomplete>
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>

                          <span class="has-text-danger" v-if="
                                  isResidentCountryCodeTouched &&
                                  !$root.formData
                                    .countryCodeForGuardianResidentialContactNum
                                ">You have to select a valid country code</span>
                        </p>
                      </b-field>
                    </section>

                  </div>
                </div>
                <div class="column">
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="Phone Number" :rules="{ onlyNumbers: true }" v-slot="{ errors }">
                        <b-input autocomplete="code_one" type="tel" v-model="$root.formData.guardianResidanceContactNumWithOutCode"
                                 @focus="$inputFocused('contact_no_resident')" @input="
                                  () => {
                                    $inputChanged('contact_no_resident');
                                    contactResidanceContactNo();
                                    calResidanceNumber();
                                  }
                                " @blur="$inputBlured('contact_no_resident')" />
                        <span class="icon is-small is-right mr-2">
                                <img src="../../../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                     height="25" />
                              </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="isResidanceNumberLocal">LK Numbers cannot start with 0</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>
              </div>
            </div>
          </div>



          <!-- contactNumberOffice -->
          <div class="mt-5">
            <div class="icon-text" :style="{
                    cursor: 'pointer',
                    color: '#009ec2',
                    'line-height': '20px',
                    'text-decoration': 'underline',
                    'letter-spacing': '0.7px',
                  }">
              <p v-if="!isHide" @click="visible()">
                      <span class="icon has-text-info">
                        <img src="../../../assets/images/icons/Blue/Circle Plus.png" alt="Circle_Plus image" />
                      </span>
                <span v-if="!isHide">{{$root.selectedLanguageData.contactNumberOffice }}</span>
              </p>
            </div>
            <div v-if="isHide">
              <div v-if="isHide" @click="() => {visibleNot();changeOfficeContactNumCountryCode();$root.formData.guardianOfficeCountryCode = '+94';$root.formData.guardianOfficeContactNumWithOutCode = ''  } " class="mb-2">
                <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                        <span class="icon has-text-info mr-2">
                          <img src="../../../assets/images/icons/Blue/Circle Minus.png"
                               alt="Circle_Mini image" /></span>
                  {{ $root.selectedLanguageData.contactNumberOffice }}
                </label>
              </div>
              <div class="columns is-7 is-variable">
                <div class="column is-one-third">
                  <div>
                    <section>
                      <p class="control has-icons-right">
                        <ValidationProvider name="Country Code"
                                            v-slot="{ errors }">
                          <b-autocomplete autocomplete="code_three" @input="countryCodeLogoFilter" v-model="$root.formData.guardianOfficeCountryCode" placeholder="Office Country Code" icon-pack="fi" :icon="$root.formData.guardianCountryIconStringOffice"
                                          :data="filteredDataArray"
                                          clearable
                                          open-on-focus
                                          @select="option => selected = option">
                            <template #empty>No results found</template>
                          </b-autocomplete>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <span class="has-text-danger" v-if="isWorkCountryCodeTouched &&!$root.formData.countryCodeForGuardianOfficeContactNum">
                                You have to select a valid country code
                              </span>
                      </p>
                    </section>
                  </div>
                </div>
                <div class="column">
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="Phone Number" :rules="{ onlyNumbers: true }" v-slot="{ errors }">
                        <b-input autocomplete="code" type="tel" v-model="$root.formData.guardianOfficeContactNumWithOutCode"
                                 @focus="$inputFocused('contact_no_work')" @blur="$inputBlured('contact_no_work')" @input="
                                  () => {
                                    $inputChanged('contact_no_work');
                                    calOfficeNumber();
                                    contactOfficeContactNo();
                                  } " />
                        <span class="icon is-small is-right mr-2">
                                <img src="../../../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                     height="25" />
                              </span>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="isOfficeNumberLocal">LK numbers can't start with 0</span>
                      </ValidationProvider>
                    </p>
                  </b-field>
                </div>
              </div>
            </div>
          </div>









        <hr/>
        <RadioButtonField
          :label="$root.selectedLanguageData.areYouaUSPerson"
          v-model="$root.formData.guardian_us_person"
          :radioOptions="$root.selectedLanguageData.yes_no_list"
          name="are_you_a_us_person"
          styles="mt-5"
          itemList="residentship-item"
          :validationRules="{ required: true }"
        />
        <div v-if="$root.formData.guardian_us_person">
          <p class="gray_font">
            <span class="has-text-danger">*</span
            >{{ $root.selectedLanguageData.citizen_of_usa_note }}
          </p>
          <div class="columns">
            <div class="column">
              <InputLabel
                required="true"
                :label="$root.selectedLanguageData.acc_num"
                v-model="$root.formData.guardian_acc_num"
                :validationRules="{
                  required: true,
                  regex: /^\d{12}$/
                }"
                fieldName="Account Number"
                styles="mt-5"
              />
            </div>
            <div class="column">
              <InputLabel
                required="true"
                styles="mt-5"
                :label="$root.selectedLanguageData.place_of_birth"
                v-model="$root.formData.guardian_place_of_birth"
                :validationRules="{
                  required: true,
                }"
                fieldName="Place Of Birth"
              />
            </div>
          </div>
          <!-- US Address -->
          <p class="is-size-5">
            <b> {{ $root.selectedLanguageData.us_permanent_address }}</b>
          </p>
<!--          <b-field>-->
<!--            <b-checkbox-->
<!--              :true-value="true"-->
<!--              :false-value="false"-->
<!--              v-model="$root.formData.guardian_us_permanent_address_different"-->
<!--              name="us_permanent_address_is_different"-->
<!--              :disabled="$root.formData.guardian_us_street_name || $root.formData.guardian_us_street_name || $root.formData.guardian_us_city ||$root.formData.guardian_us_city || uspermanentaddresscountry === ''"-->

<!--            ></b-checkbox>-->
<!--            <p class="gray_font">-->
<!--              {{ $root.selectedLanguageData.sameAsPermanentAddress }}-->
<!--            </p>-->
<!--          </b-field>-->
<!--          v-if="!$root.formData.guardian_us_permanent_address_different"-->
          <div>
            <InputLabel
              required="true"
              :label="$root.selectedLanguageData.houseName"
              v-model="$root.formData.guardian_us_house_name"
              :validationRules="{
                required: true,
              }"
              fieldName="House name"
            />
            <div class="columns mt-2">
              <div class="column">
                <InputLabel
                  required="true"
                  :label="$root.selectedLanguageData.streetName"
                  v-model="$root.formData.guardian_us_street_name"
                  :validationRules="{
                    required: true,
                  }"
                  fieldName="Street name"
                />
              </div>
              <div class="column">
                <InputLabel
                  required="true"
                  :label="$root.selectedLanguageData.city"
                  v-model="$root.formData.guardian_us_city"
                  :validationRules="{
                    required: true,
                  }"
                  fieldName="City"
                />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <InputLabel

                  :label="$root.selectedLanguageData.postalCode"
                  v-model="$root.formData.guardian_us_postal_code"
                  :validationRules="{

                  }"
                  fieldName="Postal code"
                />
              </div>
              <div class="column">
                <ValidationProvider
                  :rules="{ required: true }"
                  v-slot="{ errors }"
                >
                  <b-field>
                    <template #label
                      >{{ $root.selectedLanguageData.country
                      }}<span class="has-text-danger">*</span></template
                    >

                    <p class="control has-icons-right">
                      <b-autocomplete
                        v-model="uspermanentaddresscountry"
                        open-on-focus
                        :data="usCountryFilteredDataArray"
                        @select="
                          (option) => {
                            if (option) {
                              $root.formData.guardian_us_country = option.name;
                              uspermanentaddresscountry = option.name;
                              uspermanentaddresscountrycount = -1;
                            } else {
                              $root.formData.guardian_us_country = ``;
                              uspermanentaddresscountry = ``;
                            }
                          }
                        "
                        @input="
                          () => {
                            ++uspermanentaddresscountrycount;
                            if (!uspermanentaddresscountry) {
                              isUsPermanentAddressCountryTouched = false;
                              $root.formData.guardian_us_country = ``;
                            } else if (uspermanentaddresscountry) {
                              isUsPermanentAddressCountryTouched = false;
                              $root.formData.guardian_us_country =
                                uspermanentaddresscountry;
                            } else if ($root.formData.guardian_us_country) {
                              if (uspermanentaddresscountrycount > 1) {
                                isUsPermanentAddressCountryTouched = true;
                                $root.formData.guardian_us_country = ``;
                              }
                            } else if (uspermanentaddresscountrycount > 0) {
                              isUsPermanentAddressCountryTouched = true;
                              $root.formData.guardian_us_country = ``;
                            }
                          }
                        "
                        placeholder=""
                        icon=""
                        field="name"
                      >
                        <template #empty>No results found</template>
                      </b-autocomplete>
                      <span class="icon is-small is-right mx-2">
                        <img
                          src="@/assets/images/icons/Blue/Stroke.png"
                          alt="Stroke-img"
                          width="15"
                          height="15"
                        />
                      </span>
                    </p>
                  </b-field>
                  <span
                    class="has-text-danger"
                    v-if="
                      isUsPermanentAddressCountryTouched &&
                      !$root.formData.guardian_us_country
                    "
                    >You have to select a valid country</span
                  >
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <!-- mailing address -->
          <p class="is-size-5 mt-2">
            <b> {{ $root.selectedLanguageData.mailingAddress }}</b>
          </p>
          <b-field>
            <b-checkbox
                :true-value="true"
                :false-value="false"
                v-model="$root.formData.guardian_us_mailing_address_different"
                name="us_mailing_address_is_different"
                :disabled="$root.formData.guardian_us_street_name=== '' || $root.formData.guardian_us_street_name=== '' || $root.formData.guardian_us_city=== '' || uspermanentaddresscountry === ''"
                @input="guardianMailingAddressSameAsPermanentAddessInUs()"

            ></b-checkbox>
<!--            <b-checkbox-->
<!--              :true-value="true"-->
<!--              :false-value="false"-->
<!--              v-model="$root.formData.guardian_us_mailing_address_different"-->
<!--              name="us_mailing_address_is_different"-->
<!--              @input="guardianMailingAddressSameAsPermanentAddessInUs()"-->
<!--             -->
<!--            ></b-checkbox>-->
            <p class="gray_font" style="font-size: 0.9rem">
              {{ $root.selectedLanguageData.sameAsPermanentAddress }}
            </p>
          </b-field>
<!--          v-if="!$root.formData.guardian_us_mailing_address_different"-->
          <div>
            <InputLabel
              required="true"
              :label="$root.selectedLanguageData.houseName"
              v-model="$root.formData.guardian_us_mailing_house_name"
              :validationRules="{
                required: true,
              }"
              fieldName="House name"
            />
            <div class="columns mt-2">
              <div class="column">
                <InputLabel
                  required="true"
                  :label="$root.selectedLanguageData.streetName"
                  v-model="$root.formData.guardian_us_mailing_street_name"
                  :validationRules="{
                    required: true,
                  }"
                  fieldName="Street name"
                />
              </div>
              <div class="column">
                <InputLabel
                  required="true"
                  :label="$root.selectedLanguageData.city"
                  v-model="$root.formData.guardian_us_mailing_city"
                  :validationRules="{
                    required: true,
                  }"
                  fieldName="City"
                />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <InputLabel

                  :label="$root.selectedLanguageData.postalCode"
                  v-model="$root.formData.guardian_us_mailing_postal_code"
                  :validationRules="{

                  }"
                  fieldName="Postal code"
                />
              </div>
              <div class="column ">
                <ValidationProvider
                  :rules="{ required: true }"
                  v-slot="{ errors }"
                >
                  <b-field>
                    <template #label
                      >{{ $root.selectedLanguageData.country
                      }}<span class="has-text-danger">*</span></template
                    >

                    <p class="control has-icons-right">
                      <b-autocomplete
                        v-model="usmailingaddresscountry"
                        open-on-focus
                        :data="usMailingCountryFilteredDataArray"
                        @select="
                          (option) => {
                            if (option) {
                              $root.formData.guardian_us_mailing_country =
                                option.name;
                              usmailingaddresscountry = option.name;
                              usmailingaddresscountrycount = -1;
                            } else {
                              $root.formData.guardian_us_mailing_country = ``;
                              usmailingaddresscountry = ``;
                            }
                          }
                        "
                        @input="
                          () => {
                            ++usmailingaddresscountrycount;
                            if (!usmailingaddresscountry) {
                              isUsMailingAddressCountryTouched = false;
                              $root.formData.guardian_us_mailing_country = ``;
                            } else if (usmailingaddresscountry) {
                              isUsMailingAddressCountryTouched = false;
                              $root.formData.guardian_us_mailing_country =
                                usmailingaddresscountry;
                            } else if (
                              $root.formData.guardian_us_mailing_country
                            ) {
                              if (usmailingaddresscountrycount > 1) {
                                isUsMailingAddressCountryTouched = true;
                                $root.formData.guardian_us_mailing_country = ``;
                              }
                            } else if (usmailingaddresscountrycount > 0) {
                              isUsMailingAddressCountryTouched = true;
                              $root.formData.guardian_us_mailing_country = ``;
                            }
                          }
                        "
                        placeholder=""
                        icon=""
                        field="name"
                      >
                        <template #empty>No results found</template>
                      </b-autocomplete>
                      <span class="icon is-small is-right mx-2">
                        <img
                          src="@/assets/images/icons/Blue/Stroke.png"
                          alt="Stroke-img"
                          width="15"
                          height="15"
                        />
                      </span>
                    </p>
                  </b-field>
                  <span
                    class="has-text-danger"
                    v-if="
                      isUsMailingAddressCountryTouched &&
                      !$root.formData.guardian_us_mailing_country
                    "
                    >You have to select a valid country</span
                  >
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
<!--          <b-checkbox style="font-family: fira400"-->
<!--                      v-model="$root.formData.same_guardian_passport_number"-->
<!--                      @focus="$inputFocused('same_guardian_passport_number')"-->
<!--                      @blur="$inputBlured('same_guardian_passport_number')"-->
<!--                      @input="() => {$inputChanged('same_guardian_passport_number')}"-->
<!--                      @change.native="sameAsAbovePassport()">-->
<!--            {{ $root.selectedLanguageData.same_as_the_previously_entered }}-->
<!--          </b-checkbox>-->
          <b-field>


            <b-checkbox
                :disabled="$root.formData.guardian_passport === ''"
                :true-value="true"
                :false-value="false"
                v-model="$root.formData.same_guardian_passport_number"
                @change.native="sameAsAbovePassport()"
            >{{ $root.selectedLanguageData.same_as_the_previously_entered_passport_number }}</b-checkbox>
            </b-field>
          <InputLabel
          :disabled="$root.formData.same_guardian_passport_number===true"
            required="true"
            styles="mt-4"
            :label="$root.selectedLanguageData.passport_no"
            v-model="$root.formData.guardian_us_passport"
            :validationRules="passportValidateObject()"
            fieldName="Your us passport number"
          ></InputLabel>

                 <!--us_person_telephone number -->
                    <div class="mt-4">
                      <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: `` }`">
                        {{ $root.selectedLanguageData.us_telephone_number }}
                        <span class="has-text-danger">*</span></label>
                      <div class="columns is-7 is-variable">
                        <div class="column is-one-third">
                          <div>
                            <b-field>
                              <ValidationProvider name="your country code" :rules="{ required: true }" v-slot="{ errors }">
                                <b-select @input="changeGuardianUsContactNumCountryCode()"
                                          v-model="$root.formData.guardianUsTellCountryCode" icon-pack="fi" :icon="iconStringUsGuardian" disabled>
                                  <option v-for="country in $root.formData.countriesList" :key="country.code" :value="country.code">
                                    {{ country.phone }}
                                  </option>
                                </b-select>
                                <span class="has-text-danger">{{errors[0] }}</span>
                              </ValidationProvider>
                            </b-field>
                          </div>
                        </div>
                        <div class="column">
                          <b-field>
                            <p class="control has-icons-right">
                              <ValidationProvider name="US Telephone Number" :rules="{required: true,onlyNumbers: true,}" v-slot="{ errors }">
                                <b-input type="tel" v-model="$root.formData.guardian_us_tel_number"
                                         @focus="$inputFocused('guardian_us_tel_number')"
                                         @blur="$inputBlured('guardian_us_tel_number')"
                                         @input="() => {$inputChanged('guardian_us_tel_number');calGuardianUsContactNumber();}" />
                                <span class="icon is-small is-right mr-2">
                                  <img src="@/assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                                       height="25" />
                                </span>
                                <span class="has-text-danger">{{errors[0] }}</span>
                              </ValidationProvider>
                            </p>
                          </b-field>
                        </div>
                      </div>
                    </div>
          <InputLabel
            required="true"
            styles="mt-5"
            :label="$root.selectedLanguageData.tax_id_number"
            v-model="$root.formData.guardian_tax_idetification_number"
            :validationRules="{ required: true }"
            fieldName="Your Tax Identification Number"
          />
        </div>
          <RadioButtonField
          :validationRules="{ required: true }"
            :label="$root.selectedLanguageData.are_you_a_tax_payer"
            v-model="$root.formData.guardian_are_you_a_tax_payer"
            :radioOptions="$root.selectedLanguageData.yes_no_list"
            name="are_you_a_tax_payer"
            styles="mt-5"
            itemList="residentship-item"
            @input="
              (receivedValue) => {
                if (!receivedValue) {
                  $root.formData.guardian_tax_file_number = ``;
                }
              }
            "
          />
          <InputLabel
            v-if="$root.formData.guardian_are_you_a_tax_payer"
            styles="mt-4"
            :label="$root.selectedLanguageData.enter_tax_number"
            v-model="$root.formData.guardian_tax_file_number"
            fieldName="Tax File Number"
            :validationRules="{ required: true }"
          />
          <RadioButtonField
          :validationRules="{ required: true }"
            :label="$root.selectedLanguageData.are_you_a_political_exposed"
            v-model="$root.formData.guardian_political_exposed"
            :radioOptions="$root.selectedLanguageData.yes_no_list"
            name="are_you_political_exposed"
            styles="mt-5"
            itemList="residentship-item"
            @input="
              (receivedValue) => {
                if (!receivedValue) {
                  $root.formData.guardian_political_exposed_position = ``;
                }
              }
            "
          />
          <InputLabel
          required="true"
            v-if="$root.formData.guardian_political_exposed"
            styles="mt-4"
            :label="$root.selectedLanguageData.specify_the_position"
            v-model="$root.formData.guardian_political_exposed_position"
            fieldName="Political exposed position"
            :validationRules="{ required: true, notStartsWith: ' ', notEndsWith: ' ', alphaSpaces: true }"
          />
          <RadioButtonField
          :validationRules="{ required: true,  }"
            :label="
              $root.selectedLanguageData
                .closer_relatives_or_associates_politically_exposed
            "
            v-model="
              $root.formData.guardian_closer_relatives_politically_exposed
            "
            :radioOptions="$root.selectedLanguageData.yes_no_list"
            name="close_relative_political_exposed"
            styles="mt-5"
            itemList="residentship-item"
            @input="
              (receivedValue) => {
                if (!receivedValue) {
                  $root.formData.guardian_closer_relatives_position = ``;
                  $root.formData.guardian_closer_relatives_designation = ``;
                }
              }
            "
          />
          <InputLabel
          required="true"
            styles="mt-4"
            v-if="$root.formData.guardian_closer_relatives_politically_exposed"
            :label="$root.selectedLanguageData.name"
            v-model="$root.formData.guardian_closer_relatives_position"
            fieldName="Guardian closer relatives position"
            :validationRules="{ required: true, notStartsWith: ' ', notEndsWith: ' ', alphaSpaces: true }"
          />
          <!-- <InputLabel
          required="true"
            styles="mt-4"
            v-if="$root.formData.guardian_closer_relatives_politically_exposed"
            :label="$root.selectedLanguageData.specify_the_designation"
            v-model="$root.formData.guardian_closer_relatives_designation"
            fieldName="Guardian closer relatives designation"
            :validationRules="{ required: true, notStartsWith: ' ', notEndsWith: ' ', alphaSpaces: true }"
          /> -->
          <p class="gray_font">
            <span class="has-text-danger">*</span
            >{{ $root.selectedLanguageData.public_positions_note }}
          </p>
        </div>
        <PageButton
          :disabled="invalid"
          :previousButtonFunction="
            () => {
              previousPagePusher()
            }
          "
          :nextButtonFunction="
            () => {
             submitPageInputs(isContinueButtonLoading, nextPagePusher(), previousRouteString, nextPagePusher(), 1)
            }
          "
        />
      </form>
    </ValidationObserver>
  </div>

</template>
<script>
import PageHeaderPart from "../page-header-part/page-header-part.vue";
import guardiansHeaderImg from "@/assets/images/icons/Blue/man_baba.webp";
import PageButton from "../page-button/page-button.vue";
import InputLabel from "../fields/input-field.vue";
import SelectLabel from "../fields/select-field.vue";
import RadioButtonField from "../fields/radio-field.vue";
import {submitPageInputs} from "@/util/util";
export default {
  name: "GuardiansInfo",
  components: {
    PageHeaderPart,
    PageButton,
    InputLabel,
    SelectLabel,
    RadioButtonField,
  },
  data() {
    return {
      guardiansHeaderImg: guardiansHeaderImg,
      iconString: "",
      userCode: "",
      countryOfficeCode: "",
      countryCodeArray: [],
      countriesArray : [],
      count: 0,
      isMobileNumberTouched: false,
      isCountryCodeTouched: false,
      regex: {
        old_nic: /^([0-9]{9}[Xx||Vv])$/,
        passport: /^[0-9A-Za-z]{4,18}$/,
        new_nic: /[0-9]{12}/,
      },
      permanentaddresscountrycount: 0,
      isPermanentAddressCountryTouched: false,
      permanentaddresscountry: "",
      mailingaddresscountrycount: 0,
      mailingaddresscountry: "",
      isMailingAddressCountryTouched: false,
      uspermanentaddresscountrycount: 0,
      isUsPermanentAddressCountryTouched: false,
      uspermanentaddresscountry: "",
      usmailingaddresscountry: "",
      usmailingaddresscountrycount: 0,
      isUsMailingAddressCountryTouched: false,
      submitPageInputs : submitPageInputs,
      isContinueButtonLoading : false,
      previousRouteString : this.$root.formData.childrenAccountOpeningPurpose === 'For my own child' ? 'account-holder-info' : this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)" ? 'otp': '',
      isResidentCountryCodeTouched: false,
      isShow : false,
      isHide : false,
      isResidanceNumberLocal : false,
      isWorkCountryCodeTouched : false,
      isOfficeNumberLocal : false,
      iconStringOffice : "",
      iconStringUsGuardian : "fi fi-us"

    };
  },
  methods: {



    guardianContactDetailsMatcher(){
      console.log("Function kicked")

      // this.$root.formData.haveNic === 'No' || this.$root.formData.childrenAccountOpeningPurpose !== 'For another person\'s child (Gift Account)' ? this.$root.formData.guardian_details_are_different = false : this.$root.formData.guardian_details_are_different = true
      if (this.$root.formData.guardian_details_are_different===false){
        this.userCode = this.$root.formData.countryCode
        this.$root.formData.guardian_mobileNumber = this.$root.formData.mobileNumberWithoutCountryCode
        this.$root.formData.guardian_email = this.$root.formData.email
      }
      else{
        this.userCode = ""
        this.$root.formData.guardian_mobileNumber = ""
        this.$root.formData.guardian_email = ""
      }
    },
    sameAsAbovePassport(){
      if(this.$root.formData.same_guardian_passport_number=== true){
        this.$root.formData.guardian_us_passport = this.$root.formData.guardian_passport;
      }
      else {
        this.$root.formData.guardian_us_passport = ""
      }
    },

     changeGuardianUsContactNumCountryCode() {
      this.iconStringUsGuardian = `fi fi-${this.$root.formData.guardianUsTellCountryCode.toLowerCase()}`;
    },

    contactNumberResidentVisible() {
      this.isShow = true;
    },
    visible() {
      this.isHide = true;
    },
    visibleNot() {
      this.isHide = false;
      this.countryOfficeCode = "LK +94";
      this.$root.formData.countryCodeForGuardianOfficeContactNum = "+94";
      this.$root.formData.countryCodeForGuardianOfficeContactNumTemp = "LK";
      this.$root.formData.officeNumber = "";
      this.$root.formData.contact_no_work = "";
    },


    contactResidanceContactNo(){
      this.$root.formData.guardianResidentNumber = this.$root.formData.guardianResidenceCountryCode+this.$root.formData.guardianResidanceContactNumWithOutCode;
    },

    contactOfficeContactNo(){

      this.$root.formData.guardianOfficeNumber = this.$root.formData.guardianOfficeCountryCode+this.$root.formData.guardianOfficeContactNumWithOutCode

    },

    contactNumberResidentInvisible() {
      this.isShow = false;
      this.userCode = "+94";
      this.$root.formData.countryCodeForGuardianResidentialContactNum = "+94";
      this.$root.formData.countryCodeForGuardianResidentialContactNumTemp = "LK";
      this.$root.formData.guardianResidentNumber = "";
      this.$root.formData.guardian_contact_no_resident = "";
    },
    changeResidentialSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
          (countryObject) =>
              // countryObject.phone === this.$root.formData.countryCodeForResidentialContactNum
              countryObject.code === this.$root.formData.countryCodeForGuardianResidentialContactNumTemp.split(" ")[0]
      );
      this.$root.formData.guardian_resident_country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.countryIconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    changeOfficeContactNumCountryCode() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
          (countryObject) =>
              // countryObject.phone === this.$root.formData.countryCodeForOfficeContactNum
              countryObject.code === this.$root.formData.countryCodeForGuardianOfficeContactNumTemp.split(" ")[0]
      );
      this.$root.formData.guardian_office_country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.iconStringOffice = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },
     calGuardianUsContactNumber() {
      const code = this.$root.formData.countriesList.find(
        (item) => item.code === this.$root.formData.guardianUsTellCountryCode
      );
      this.$root.formData.guardian_us_person_telephone_no = `${code.phone}${this.$root.formData.guardian_us_tel_number}`;
    },



    residenceCountryCodeLogoFilter(){
      console.log('countryCodeLogoFilter --------')
      let countryCodeIndex = this.$root.dataLists.countryCodeListArray.findIndex(country => country.phone == this.$root.formData.guardianResidenceCountryCode)
      // console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
      this.$root.formData.guardianCountryIconStringResidance = `fi fi-${this.$root.dataLists.countryCodeListArray[countryCodeIndex].code.toLowerCase()}`;
      // return this.$root.formData.guardianCountryIconStringResidance;
      // console.log(this.countryIconString);
    },

    countryCodeLogoFilter(){
      console.log('countryCodeLogoFilter --------')
      let countryCodeIndex = this.$root.dataLists.countryCodeListArray.findIndex(country => country.phone == this.$root.formData.guardianOfficeCountryCode)
      // console.log('index ---'+this.countryCodeList[countryCodeIndex].code.toLowerCase())
      this.$root.formData.guardianCountryIconStringOffice = `fi fi-${this.$root.dataLists.countryCodeListArray[countryCodeIndex].code.toLowerCase()}`;
      // return this.countryIconStringOffice;
      // console.log(this.countryIconString);
    },






    nextPagePusher(){
      if (this.$root.formData.childrenAccountOpeningPurpose === 'For my own child' || this.$root.formData.haveNic === 'No'){
        return 'purpose'
      }
      else if (this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)"){
        this.$root.formData.isDonorFilled = 1
        return 'verification'
      }
    },
    splitNic() {
      // this.kycFormStore.isNicChange = true;

      if (this.$root.formData.guardian_nic.length === 10) {
        this.$root.formData.idType = "ONIC";
      } else {
        this.$root.formData.idType = "NNIC";
      }
    },

    previousPagePusher(){

      if (this.$root.formData.childrenAccountOpeningPurpose === 'For my own child' || this.$root.formData.haveNic === 'No'){
        this.$router.push('account-holder-info')
        console.log("back button")
      }
      else if (this.$root.formData.childrenAccountOpeningPurpose === "For another person's child (Gift Account)"){
        this.$router.push('otp')
      }
    },
    guardianMailingAddressSameAsPermanentAddess(){
      if (this.$root.formData.guardian_mailing_address_different) {
        this.$root.formData.guardian_mailing_house_name = this.$root.formData.guardian_house_name;
        this.$root.formData.guardian_mailing_street_name = this.$root.formData.guardian_street_name;
        this.$root.formData.guardian_mailing_city = this.$root.formData.guardian_city;
        this.$root.formData.guardian_mailing_postal_code = this.$root.formData.guardian_postal_code;
        this.mailingaddresscountry = this.permanentaddresscountry;
      }
      else {
        this.$root.formData.guardian_mailing_house_name = "";
        this.$root.formData.guardian_mailing_street_name = "";
        this.$root.formData.guardian_mailing_city  = "";
        this.$root.formData.guardian_mailing_postal_code = "";
        this.$root.formData.guardian_mailing_country = "";
      }
    },
    guardianMailingAddressSameAsPermanentAddessInUs(){
      if (this.$root.formData.guardian_us_mailing_address_different) {
        this.$root.formData.guardian_us_mailing_house_name = this.$root.formData.guardian_us_house_name;
        this.$root.formData.guardian_us_mailing_street_name = this.$root.formData.guardian_us_street_name;
        this.$root.formData.guardian_us_mailing_city = this.$root.formData.guardian_us_city;
        this.$root.formData.guardian_us_mailing_postal_code = this.$root.formData.guardian_us_postal_code;
        this.usmailingaddresscountry = this.uspermanentaddresscountry;
      }
      else {
        this.$root.formData.guardian_us_mailing_house_name = "";
        this.$root.formData.guardian_us_mailing_street_name = "";
        this.$root.formData.guardian_us_mailing_city  = "";
        this.$root.formData.guardian_us_mailing_postal_code = "";
        this.usmailingaddresscountry = "";
      }
    },

    passportValidateObject() {
      let obj = {
        required: this.$root.formData.guardian_residency === 'Out of Sri Lanka',
        notMatchRegex: [this.regex.old_nic, this.regex.new_nic],
        regex: this.regex.passport,
      };
      return obj;
    },
    validateName: function () {
      const obj = {
        required: true,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        min: 3,
      };
      return obj;
    },
    validateLine: function () {
      const obj = {
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
      };
      return obj;
    },
    validateRequeredLine: function () {
      const obj = {
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        required: true,
      };
      return obj;
    },
    //guardians mobile Nmber
    calPhoneNumber() {

      if (this.$root.formData.guardian_countryCode === "+94") {
        console.log("LK Mobile number ---------------");
        const tempMobileNumber =
          this.$root.formData.guardian_mobileNumber.trim();
        if (tempMobileNumber[0] === "0") {
          this.isMobileNumberStartsWithZero = true;
        } else {
          this.isMobileNumberStartsWithZero = false;
        }
      } else {
        this.isMobileNumberStartsWithZero = false;
      }
      this.$root.formData.guardian_contact_no = `${this.$root.formData.guardian_countryCode}${this.$root.formData.guardian_mobileNumber}`;
      console.log(
        "Contact Number Formatted : " + this.$root.formData.guardian_contact_no
      );
    },

    calResidanceNumber(){
      if(this.$root.formData.guardianResidenceCountryCode === "+94"){
        console.log("LK Mobile number ---------------");
        const tempResidance= this.$root.formData.guardianResidanceContactNumWithOutCode.trim();
        if (tempResidance[0] === "0"){
          this.isResidanceNumberLocal = true;
        }
        else {
          this.isResidanceNumberLocal = false;
        }
      }
      else {
        this.isResidanceNumberLocal = false;
      }
    },

    calOfficeNumber(){
      if(this.$root.formData.guardianOfficeCountryCode === "+94"){
        console.log("LK Mobile number ---------------");
        const tempMobileNumber = this.$root.formData.guardianOfficeContactNumWithOutCode.trim();
        if (tempMobileNumber[0] === "0"){
          this.isOfficeNumberLocal = true;
        }
        else {
          this.isOfficeNumberLocal = false;
        }
      }
      else{
        this.isOfficeNumberLocal = false;
      }

    },

    calculateDateOfBirth () {
      let year;
      let genderValue;
      let monthAndDayInDays;

      // let dateOfBirth;

      if (this.$root.formData.guardian_nic.length === 10) {
        genderValue = this.$root.formData.guardian_nic.slice(2, 5);
        monthAndDayInDays =
            parseInt(genderValue, 10) >= 500
                ? parseInt(genderValue - 500, 10)
                : parseInt(genderValue, 10);
        year = parseInt(`19${this.$root.formData.guardian_nic.slice(0, 2)}`, 10);
      } else if (this.$root.formData.guardian_nic.length === 12) {
        genderValue = this.$root.formData.guardian_nic.slice(4, 7);
        monthAndDayInDays =
            parseInt(genderValue, 10) >= 500
                ? parseInt(genderValue - 500, 10)
                : parseInt(genderValue, 10);
        year = parseInt(`${this.$root.formData.guardian_nic.slice(0, 4)}`, 10);
      }
      let month;
      let day;
      if (monthAndDayInDays <= 31) {
        month = "01";
        if (monthAndDayInDays < 10) {
          day = `0${monthAndDayInDays}`;
        } else {
          day = monthAndDayInDays;
        }
      } else if (monthAndDayInDays <= 60) {
        month = "02";
        day = monthAndDayInDays - 31;
      } else if (monthAndDayInDays <= 91) {
        month = "03";
        day = monthAndDayInDays - 60;
      } else if (monthAndDayInDays <= 121) {
        month = "04";
        day = monthAndDayInDays - 91;
      } else if (monthAndDayInDays <= 152) {
        month = "05";
        day = monthAndDayInDays - 121;
      } else if (monthAndDayInDays <= 182) {
        month = "06";
        day = monthAndDayInDays - 152;
      } else if (monthAndDayInDays <= 213) {
        month = "07";
        day = monthAndDayInDays - 182;
      } else if (monthAndDayInDays <= 244) {
        month = "08";
        day = monthAndDayInDays - 213;
      } else if (monthAndDayInDays <= 274) {
        month = "09";
        day = monthAndDayInDays - 244;
      } else if (monthAndDayInDays <= 305) {
        month = "10";
        day = monthAndDayInDays - 274;
      } else if (monthAndDayInDays <= 335) {
        month = "11";
        day = monthAndDayInDays - 305;
      } else {
        month = "12";
        day = monthAndDayInDays - 335;
      }

      this.$root.formData.guardianDob =  new Date(year, month-1, day);
      console.log(this.$root.formData.guardianDob);

      //  this.$root.formData.customer_gender = genderValue < 500 ? "Male" : "Female";
    },


    changeSelection() {
      // this.iconString = `fi fi-${this.$root.formData.guardian_country_short_name.toLowerCase()}`;
      let countryCodeIndex = this.$root.dataLists.countryCodeListArray.findIndex(country => country.phone == this.userCode)
      this.iconString = `fi fi-${this.$root.dataLists.countryCodeListArray[countryCodeIndex].code.toLowerCase()}`;

    },
    mobileNumValidate: function () {
      this.isMobileNumberTouched = true;

      if (this.$root.formData.guardian_countryCode === "+94") {
        const srilankanMobileRegEx = new RegExp(
          "^([7][0||1||2||4||5||6||7||8||][0-9]{7})$"
        );

        this.isMobileNumberValid = srilankanMobileRegEx.test(
          this.$root.formData.guardian_mobileNumber
        );
      } else {
        this.isMobileNumberValid = /^\d+$/.test(
          this.$root.formData.guardian_mobileNumber
        );
      }
    },
    passportExpireDateCalculator(){

      if( this.$root.formData.guardian_passport_issue_date !== ''){
        console.log("this.$root.formData.guardian_passport_issue_date", this.$root.formData.guardian_passport_issue_date.getFullYear())
        this.$root.formData.guardian_passport_expiry_date = new Date(this.$root.formData.guardian_passport_issue_date.getFullYear()+10, this.$root.formData.guardian_passport_issue_date.getMonth(), this.$root.formData.guardian_passport_issue_date.getDate())
      }
    },

    // mobile Nmber
  },
  computed: {

    

    residenceFilteredDataArray() {
      return this.$root.dataLists.countryCodeNumbersListArray.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.$root.formData.guardianResidenceCountryCode.toLowerCase())
      })
    },

    filteredDataArray() {
      return this.$root.dataLists.countryCodeNumbersListArray.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.$root.formData.guardianOfficeCountryCode.toLowerCase())
      })
    },



    filteredDataArr() {
      return this.$root.dataLists.countryCodeNumbersListArray.filter((option) => {
        return option.toLowerCase().indexOf(this.userCode.toLowerCase()) >= 0;
      });
    },
    countryFilteredDataArray() {
      return this.$root.formDataSupport.countriesArray.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.permanentaddresscountry.toLowerCase()) >= 0
        );
      });
    },
    mailingCountryFilteredDataArray() {
      return this.$root.formDataSupport.countriesArray.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.mailingaddresscountry.toLowerCase()) >= 0
        );
      });
    },
    usCountryFilteredDataArray() {
      return this.$root.formDataSupport.countriesArray.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.uspermanentaddresscountry.toLowerCase()) >= 0
        );
      });
    },


    usMailingCountryFilteredDataArray() {
      return this.$root.formDataSupport.countriesArray.filter((option) => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.usmailingaddresscountry.toLowerCase()) >= 0
        );
      });
    },


  },
  mounted: function () {
       if (this.$root.formData.guardian_details_are_different===false && this.$root.formData.childrenAccountOpeningPurpose !== `For another person's child (Gift Account)`){
        this.userCode = this.$root.formData.countryCode
        this.$root.formData.guardian_mobileNumber = this.$root.formData.mobileNumberWithoutCountryCode
        this.$root.formData.guardian_email = this.$root.formData.email
      }
      
    this.countriesArray = this.$root.selectedLanguageData.countries.filter(
        (item) => item.value !== "Sri Lanka"
    );
    console.log("countries array ",this.countriesArray)

   if(this.$root.formData.$root.formData.haveNic=== 'No') {
      this.userCode = this.$root.formData.countryCode
      this.$root.formData.guardian_mobileNumber = this.$root.formData.mobileNumberWithoutCountryCode
      this.$root.formData.guardian_email = this.$root.formData.email
    }



    for (const country of this.$root.formDataSupport.countriesArray) {
      this.countryCodeArray.push(`${country.code} ${country.shortName}`);
    }

    if (!this.$root.formData.guardian_countryCode) {
      this.$root.formData.guardian_countryCode = "+94";
      this.$root.formData.guardian_country_short_name = "LK";
    }

    const tempCountryCodeName = this.$root.formDataSupport.countriesArrayspecifyTheCountry.find(
      (country) =>
        country.shortName === this.$root.formData.guardian_country_short_name
    );

    this.userCode = this.countryCodeArray.find(
      (hello) =>
        hello ===
        `${this.$root.formData.guardian_countryCode} ${tempCountryCodeName.shortName}`
    );
    this.changeSelection();
    this.changeGuardianUsContactNumCountryCode();
   

  },




};
</script>
<style>
.residentship-item {
  width: 292px !important;
  height: 45px !important;
  padding: 12px !important;
}
</style>
